import {
	ArrowUpDown,
	BarChart2,
	Bell,
	Calendar,
	ClipboardList,
	FileText,
	BarChart3,
	Hash,
	Heart,
	Heading,
	Image,
	Layout,
	Link,
	MapPin,
	Maximize,
	Megaphone,
	Menu,
	Shield,
	Smartphone,
	Tag,
	Palette,
	Rss,
	Users,
	UserCircle,
	type LucideIcon
} from "lucide-react";

export interface NavItem {
	label: string;
	icon: LucideIcon;
	path?: string;
	children?: NavItem[];
	guard?: {
		specificGroup?: string;
		restrictedToEstateManager?: boolean;
		admin?: boolean;
	};
}

export const navigationConfig: NavItem[] = [
	{
		label: "Analytics",
		icon: BarChart2,
		path: "/analytics"
	},
	{
		label: "Announcements",
		icon: Bell,
		path: "/announcements"
	},
	{
		label: "App",
		icon: Smartphone,
		children: [
			{
				label: "Events",
				icon: Calendar,
				path: "/app/events"
			},
			{
				label: "Homepage",
				icon: Layout,
				children: [
					{
						label: "Branding",
						icon: Palette,
						path: "/vendor-sponsorship/app-branding/brands?published=true"
					},
					{
						label: "Carousel",
						icon: Image,
						path: "/vendor-sponsorship/homepage-carousel/banners?published=true"
					},
					{
						label: "Key Shouts",
						icon: Megaphone,
						path: "/app/homepage/key-shouts"
					},
					{
						label: "Ordering",
						icon: ArrowUpDown,
						path: "/app/homepage/ordering"
					},
					{
						label: "Promotions",
						icon: Tag,
						path: "/vendor-sponsorship/promotion/banners?published=true"
					},
					{
						label: "Quick Links",
						icon: Link,
						path: "/app/homepage/quick-links"
					},
					{
						label: "Section Titles",
						icon: Heading,
						path: "/app/homepage/section-titles"
					},
					{
						label: "Takeovers",
						icon: Maximize,
						path: "/vendor-sponsorship/full-screen-takeover/banners?published=true"
					}
				]
			},
			{
				label: "Navigation",
				icon: Menu,
				path: "/app/navigation"
			},
			{
				label: "Social Feed",
				icon: Rss,
				children: [
					{
						label: "Favourites",
						icon: Heart,
						path: "/social-feed/favourite-feeds"
					},
					{
						label: "Hashtags",
						icon: Hash,
						path: "/social-feed/hashtags"
					},
					{
						label: "Overview",
						icon: Rss,
						path: "/social-feed"
					}
				]
			}
		]
	},
	{
		label: "Observations",
		icon: ClipboardList,
		children: [
			{
				label: "Forms",
				icon: FileText,
				path: "/observations/forms",
				guard: { admin: true, specificGroup: "observation-editors" }
			},
			{
				label: "Reports",
				icon: BarChart3,
				path: "/observations/reports",
				guard: { admin: true, specificGroup: "observation-reporting" }
			},
			{
				label: "Submissions",
				icon: ClipboardList,
				path: "/observations/submissions"
			}
		]
	},
	{
		label: "Users",
		icon: Users,
		children: [
			{
				label: "Groups",
				icon: Users,
				path: "/users/groups"
			},
			{
				label: "Locations",
				icon: MapPin,
				path: "/users/locations"
			},
			{
				label: "People",
				icon: UserCircle,
				path: "/users/people"
			},
			{
				label: "Permissions",
				icon: Shield,
				path: "/users/permissions"
			}
		]
	}
];
